/* EARO · panier maison (Claude, 16/10/2026, demande de Benjamin). Remplace Upcart.
   - S'ouvre après chaque ajout : Rapi appelle window.upcartOpenCart() ; les autres ajouts sont repérés sur /cart/add.
   - Cadeaux Rapi rangés sous leur article (« ↳ … GRATUIT ») avec compteur : « + » ajoute une unité payante
     (ligne à part, jamais rendue gratuite par Rapi), « − » retire les unités payantes et s'arrête au nombre offert.
   - Propositions : petites lignes, jamais un article déjà au panier, 4 au plus (Anti-Acouphènes d'abord sous un Earo) ;
     pas de 2e Earo (AfterSell après l'achat).
   - Rapide : les réponses de /cart/change.js et /cart/update.js (panier complet) sont affichées sans nouvelle requête.
   - API Ajax de Shopify (/cart.js, /cart/add.js, /cart/change.js, /cart/update.js) et rendu de section pour l'icône. */
(function () {
  if (window.earoPanier) return;

  var C = {
    seuilLivraison: 4000,            // livraison offerte dès 40 € (en euros seulement)
    earo: 15716874158463,
    earoSeul: 58102469394815,
    kit: 58102469427583,
    acouphenes: 15640263295359,
    // Sous un Earo Vision : l'Anti-Acouphènes d'abord (Benjamin, 16/10 : « il faudrait absolument le proposer »).
    vision: ['anti-acouphenes-complex', 'pack-20-embouts-en-silicone-medical', 'earo-spray', 'pochette-rangement'],
    maxPropositions: 4,             // Earo seul : Anti-Acouphènes, pack 20, spray, pochette (Benjamin, 16/10)
    acou: ['earo-vision-2-0', 'earo-spray'],
    sous: {
      'pack-20-embouts-en-silicone-medical': '20 embouts en silicone médical',
      'earo-spray': 'Anti-bouchons de cérumen',
      'pochette-rangement': "Pour ranger l'Earo et ses embouts",
      'earo-vision-2-0': 'Caméra HD, appli iOS et Android',
      'anti-acouphenes-complex': '11 actifs pour éteindre le sifflement'
    },
    garantie: 'Satisfait ou remboursé 45 jours',
    reservation: 10 * 60 * 1000,     // « Votre commande est réservée pendant 10:00 », relancée à zéro
    // Cadeau texte de l'offre Rapi « Cure Optimale (3 mois) » : affiché sous l'Anti-Acouphènes à partir de 3 flacons (pas une ligne de commande).
    guideAcou: { nom: 'Guide anti-acouphènes (ebook)', quantiteMin: 3,
      image: 'https://cdn.shopify.com/s/files/1/0916/4177/4463/files/1776777036Rapi-Bundles-freeGifts-0_300x300.png?v=1776777040' },
    pageEaro: '/products/earo-vision-2-0'
  };

  var fetchOrigine = window.fetch.bind(window);
  var panier = window.earoPanierInitial || null;
  var produits = {};
  var racine, corps, occupe = false, minuteurErreur = null;

  // ---------- Outils ----------
  function euros(centimes) {
    var devise = (panier && panier.currency) || 'EUR';
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: devise }).format(centimes / 100); }
    catch (e) { return (centimes / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function echapper(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function image(url, largeur) {
    if (!url) return '';
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + (largeur || 120);
  }
  function offre(ligne) {
    try { return JSON.parse((ligne.properties || {}).__rapi_offer || 'null'); } catch (e) { return null; }
  }
  function estPanier(d) { return d && Array.isArray(d.items) && typeof d.item_count === 'number'; }
  // Erreurs Shopify (422 : stock, quantité maximale…) remontées avec leur message.
  // Délai maximum de 10 s par requête : un réseau lent ou une réponse qui ne vient pas ne bloque jamais le panier.
  function json(url, options) {
    var arret = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var minuteur = arret ? setTimeout(function () { arret.abort(); }, 10000) : null;
    var opts = Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, options || {});
    if (arret) opts.signal = arret.signal;
    return fetchOrigine(url, opts)
      .catch(function (e) {
        var err = new Error(e && e.name === 'AbortError' ? 'Connexion lente : le panier n’a pas répondu. Réessayez.' : 'Connexion impossible. Vérifiez votre réseau et réessayez.');
        err.statut = 0;
        throw err;
      })
      .then(function (r) {
        clearTimeout(minuteur);
        return r.json().catch(function () { return null; }).then(function (d) {
          if (!r.ok) {
            var err = new Error((d && (d.description || d.message)) || ('Erreur ' + r.status));
            err.statut = r.status;
            throw err;
          }
          return d;
        });
      });
  }

  // ---------- Squelette ----------
  function construire() {
    if (racine) return;
    racine = document.createElement('div');
    racine.className = 'earo-panier';
    racine.innerHTML =
      '<div class="earo-panier__voile" data-fermer></div>' +
      '<aside class="earo-panier__tiroir" role="dialog" aria-modal="true" aria-labelledby="earo-panier-titre">' +
        '<div class="earo-panier__tete"><h2 class="earo-panier__titre" id="earo-panier-titre">Votre panier</h2>' +
        '<button type="button" class="earo-panier__fermer" data-fermer aria-label="Fermer le panier">' +
        '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16"/></svg></button></div>' +
        '<div class="earo-panier__reserve" hidden></div>' +
        '<div class="earo-panier__livraison"></div>' +
        '<p class="earo-panier__erreur" role="alert" hidden></p>' +
        '<div class="earo-panier__corps"></div>' +
        '<div class="earo-panier__pied" aria-live="polite"></div>' +
      '</aside>';
    document.body.appendChild(racine);
    corps = racine.querySelector('.earo-panier__corps');
    racine.addEventListener('click', clic);
    document.addEventListener('keydown', clavier);
  }
  function clavier(e) {
    if (!racine || !racine.hasAttribute('data-ouvert')) return;
    if (e.key === 'Escape') { fermer(); return; }
    if (e.key !== 'Tab') return;
    // Le focus reste dans le panier ouvert.
    var f = [].slice.call(racine.querySelectorAll('.earo-panier__tiroir button:not([disabled]), .earo-panier__tiroir a[href]'));
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  // ---------- Rendu ----------
  function rendre() {
    construire();
    var lignes = (panier && panier.items) || [];
    var nb = (panier && panier.item_count) || 0;
    racine.querySelector('.earo-panier__titre').textContent = 'Votre panier' + (nb ? ' · ' + nb : '');

    var total = (panier && panier.total_price) || 0;
    var euro = !panier || !panier.currency || panier.currency === 'EUR';
    var reste = C.seuilLivraison - total;
    racine.querySelector('.earo-panier__reserve').hidden = !nb;
    if (nb) majReservation();
    var bandeau = racine.querySelector('.earo-panier__livraison');
    if (!nb || !euro) { bandeau.hidden = true; } else {
      bandeau.hidden = false;
      bandeau.innerHTML = '<p>' + (reste > 0 ? 'Ajoutez <strong>' + euros(reste) + '</strong> pour obtenir la livraison offerte !' : '✅ Livraison offerte débloquée !') + '</p>' +
        '<div class="earo-panier__barre"><span style="width:' + Math.min(100, Math.round(total * 100 / C.seuilLivraison)) + '%"></span></div>';
    }

    if (!nb) {
      corps.innerHTML = '<div class="earo-panier__vide"><p>Votre panier est vide.</p><a href="' + C.pageEaro + '">Découvrir Earo Vision 2.0</a></div>';
      racine.querySelector('.earo-panier__pied').innerHTML = '';
      return;
    }

    // Cadeaux Rapi rangés sous leur article principal, avec les unités ajoutées en plus (payantes, ligne à part).
    var principales = [], cadeaux = {}, supplements = {};
    lignes.forEach(function (l) {
      var o = offre(l);
      var sup = (l.properties || {})._earo_cadeau;
      if (o && o.gift) { (cadeaux[o.id] = cadeaux[o.id] || []).push(l); }
      else if (sup) { (supplements[sup] = supplements[sup] || []).push(l); }
      else { principales.push(l); }
    });
    // Un supplément dont le cadeau n'est plus là redevient une ligne normale.
    Object.keys(supplements).forEach(function (id) {
      supplements[id].forEach(function (x) {
        if (!(cadeaux[id] || []).some(function (g) { return g.variant_id === x.variant_id; })) principales.push(x);
      });
    });
    // Ordre d'ajout (Shopify met le dernier ajout en tête), article Rapi d'abord.
    principales.reverse().sort(function (a, b) { var oa = offre(a), ob = offre(b); return (ob && ob.main ? 1 : 0) - (oa && oa.main ? 1 : 0); });
    var html = '';
    var places = {};
    var ebookPlace = false;
    principales.forEach(function (l) {
      html += ligneHtml(l);
      var o = offre(l);
      // Guide anti-acouphènes montré une fois, sous l'Anti-Acouphènes à partir de la cure de 3 mois.
      var avecEbook = !ebookPlace && l.product_id === C.acouphenes && l.quantity >= C.guideAcou.quantiteMin;
      if (avecEbook) ebookPlace = true;
      if (o && o.main && cadeaux[o.id] && !places[o.id]) { html += cadeauxHtml(cadeaux[o.id], supplements[o.id], o.id, avecEbook); places[o.id] = true; }
      else if (avecEbook) html += '<div class="earo-cadeaux">' + ebookHtml() + '</div>';
    });
    Object.keys(cadeaux).forEach(function (id) { if (!places[id]) html += cadeauxHtml(cadeaux[id], supplements[id], id); });
    html += propositionsHtml(lignes);
    corps.innerHTML = html;

    var original = lignes.reduce(function (s, l) { return s + prixBarre(l); }, 0);
    racine.querySelector('.earo-panier__pied').innerHTML =
      '<div class="earo-panier__total"><span>Sous-total</span><span>' + (original > total ? '<s>' + euros(original) + '</s>' : '') + '<strong>' + euros(total) + '</strong></span></div>' +
      '<button type="button" class="earo-panier__commander" data-commander>Commander · ' + euros(total) + '</button>' +
      paiementsHtml() +
      '<p class="earo-panier__garantie">' + C.garantie + '</p>';
  }

  // Icônes des moyens de paiement, préparées par le thème selon le pays du visiteur (snippet earo-panier).
  var paiements = null;
  function paiementsHtml() {
    if (paiements === null) { var tpl = document.getElementById('earo-panier-paiements'); paiements = tpl ? tpl.innerHTML.trim() : ''; }
    return paiements ? '<div class="earo-panier__paiements" role="img" aria-label="Moyens de paiement acceptés">' + paiements + '</div>' : '';
  }
  // Prix barré d'un article : celui que la page produit affiche, lu dans l'offre Rapi (prix barré saisi dans Rapi).
  // Ex. au 16/10 : Earo seul 37,90 € au lieu de 60,00 €, Kit 49,90 € au lieu de 90,00 €, cure 3 mois 59,90 € au lieu de 120,00 €.
  var offresCache = null;
  function offresRapi() {
    if (offresCache) return offresCache;
    var res = {};
    try {
      var src = window.__appDataMetaobject || {};
      Object.keys(src).forEach(function (k) {
        if (k.indexOf('bundle_') !== 0) return;
        var b = typeof src[k] === 'string' ? JSON.parse(src[k]) : src[k];
        if (b && Array.isArray(b.offers)) res[String(b.id)] = b.offers;
      });
    } catch (e) {}
    if (Object.keys(res).length) offresCache = res;
    return res;
  }
  function offreDeLigne(l) {
    var o = offre(l), lot = (l.properties || {})._rapi_bundles;
    if (!o || !o.main || !lot) return null;
    var offres = offresRapi()[String(lot)] || [];
    var memeQte = offres.filter(function (x) { return Number(x.quantity) === l.quantity; });
    return memeQte.filter(function (x) { return x.identifier_id === o.offer; })[0] || (memeQte.length === 1 ? memeQte[0] : null) ||
      offres.filter(function (x) { return x.identifier_id === o.offer; })[0] || null;
  }
  function prixBarre(l) {
    var of = offreDeLigne(l);
    var ref = of && parseFloat(of.manual_compare_at_price);
    if (!ref) return l.original_line_price;
    // Hors euro (Canada, 26/10) : le prix barré Rapi est saisi en euros ; converti au taux Shopify et arrondi à l'unité supérieure,
    // comme sur la page produit (snippets/earo-textes-canada.liquid).
    var pm = of.per_market_pricing, pays = window.Shopify && Shopify.country;   // prix barré réglé pour ce pays dans Rapi : déjà dans la devise
    pm = pm && pays ? Object.keys(pm).map(function (k) { return pm[k]; }).filter(function (m) { return m && m.overrideCompareAt && m.countries && m.countries.indexOf(pays) >= 0; })[0] : null;
    if (pm) ref = Math.ceil(parseFloat(pm.compareAtPrice));
    else if (panier && panier.currency && panier.currency !== 'EUR') ref = Math.ceil(ref * (parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1));
    var fois = Math.max(1, Math.round(l.quantity / (Number(of.quantity) || 1)));
    return Math.max(l.original_line_price, Math.round(ref * 100) * fois);
  }
  function ligneHtml(l) {
    var variante = l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '';
    if (l.variant_id === C.earoSeul) variante = 'Earo seul';
    var barre = prixBarre(l);
    var remise = barre - l.final_line_price;
    return '<div class="earo-ligne" data-cle="' + echapper(l.key) + '">' +
      '<img class="earo-ligne__img" src="' + echapper(image(l.image, 120)) + '" alt="" width="56" height="56">' +
      '<div class="earo-ligne__nom">' + echapper(l.product_title) + (variante ? '<span class="earo-ligne__offre">' + echapper(variante) + '</span>' : '') + '</div>' +
      '<div class="earo-ligne__prix">' + euros(l.final_line_price) + (remise > 0 ? '<s>' + euros(barre) + '</s>' : '') + '</div>' +
      '<div class="earo-ligne__actions">' +
        '<div class="earo-qte"><button type="button" data-qte="-1" aria-label="Retirer un ' + echapper(l.product_title) + '">−</button><span>' + l.quantity + '</span>' +
        '<button type="button" data-qte="1" aria-label="Ajouter un ' + echapper(l.product_title) + '">+</button></div>' +
        '<button type="button" class="earo-ligne__suppr" data-suppr aria-label="Supprimer ' + echapper(l.product_title) + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button>' +
        (remise > 0 ? '<span class="earo-economie"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.4 11.6l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .55.22 1.05.59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.82zM6.5 8A1.5 1.5 0 1 1 6.5 5a1.5 1.5 0 0 1 0 3z"/></svg>Vous économisez <strong>' + euros(remise) + '</strong></span>' : '') +
      '</div></div>';
  }

  function ebookHtml() {
    var g = C.guideAcou;
    return '<div class="earo-cadeau earo-cadeau--inclus"><span class="earo-cadeau__fleche" aria-hidden="true">↳</span>' +
      '<img src="' + echapper(g.image) + '" alt="" width="30" height="30">' +
      '<span class="earo-cadeau__nom">' + echapper(g.nom) + '</span><span></span>' +
      '<span class="earo-cadeau__prix">GRATUIT</span></div>';
  }
  function cadeauxHtml(liste, sups, id, avecEbook) {
    return '<div class="earo-cadeaux">' + liste.map(function (g) {
      var x = (sups || []).filter(function (s) { return s.variant_id === g.variant_id; })[0];
      var paye = x ? x.quantity : 0;
      var prix = paye
        ? '<span class="earo-cadeau__prix">' + euros(x.final_line_price) + '<small>' + g.quantity + ' offert' + (g.quantity > 1 ? 's' : '') + '</small></span>'
        : '<span class="earo-cadeau__prix">GRATUIT' + (g.original_line_price > 0 ? '<s>' + euros(g.original_line_price) + '</s>' : '') + '</span>';
      return '<div class="earo-cadeau" data-cadeau="' + echapper(g.key) + '"' + (x ? ' data-sup="' + echapper(x.key) + '"' : '') + ' data-offre="' + echapper(id) + '">' +
        '<span class="earo-cadeau__fleche" aria-hidden="true">↳</span>' +
        '<img src="' + echapper(image(g.image, 80)) + '" alt="" width="30" height="30">' +
        '<span class="earo-cadeau__nom">' + echapper(g.product_title) + '</span>' +
        '<div class="earo-qte earo-qte--petit"><button type="button" data-cqte="-1" aria-label="Retirer un ' + echapper(g.product_title) + '"' + (paye ? '' : ' disabled title="Offert avec votre offre"') + '>−</button><span>' + (g.quantity + paye) + '</span>' +
        '<button type="button" data-cqte="1" aria-label="Ajouter un ' + echapper(g.product_title) + '">+</button></div>' +
        prix + '</div>';
    }).join('') + (avecEbook ? ebookHtml() : '') + '</div>';
  }

  function propositionsHtml(lignes) {
    var dans = {}, nbEaro = 0, acou = false;
    lignes.forEach(function (l) {
      dans[l.handle] = true;
      if (l.product_id === C.earo) nbEaro += l.quantity;
      if (l.product_id === C.acouphenes) acou = true;
    });
    var liste = nbEaro ? C.vision : (acou ? C.acou : []);
    var rangs = [];
    liste.forEach(function (h) {
      var p = produits[h];
      if (!p || dans[h] || rangs.length >= C.maxPropositions) return;
      var v = h === 'earo-vision-2-0' ? p.variants.filter(function (x) { return x.id === C.earoSeul; })[0] : p.variants[0];
      if (!v || !v.available) return;
      rangs.push('<div class="earo-proposition"><img src="' + echapper(image(p.featured_image, 100)) + '" alt="" width="40" height="40" loading="lazy">' +
        '<div class="earo-proposition__nom">' + echapper(p.title) + '<span>' + echapper(C.sous[h] || '') + '</span></div>' +
        '<button type="button" data-ajouter="' + v.id + '" aria-label="Ajouter ' + echapper(p.title) + ' pour ' + euros(v.price) + '">+ ' + euros(v.price) + '</button></div>');
    });
    return rangs.length ? '<p class="earo-propositions__titre">Pour compléter</p>' + rangs.join('') : '';
  }

  // Réservation de 10 minutes : l'échéance est gardée d'une page à l'autre ; arrivée à zéro, elle repart pour 10 minutes.
  var minuteurReserve = null;
  function echeance() {
    var maintenant = Date.now(), fin = 0;
    try { fin = Number(localStorage.getItem('earoPanierReserve')) || 0; } catch (e) {}
    if (fin <= maintenant || fin - maintenant > C.reservation) {
      fin = maintenant + C.reservation;
      try { localStorage.setItem('earoPanierReserve', String(fin)); } catch (e) {}
    }
    return fin;
  }
  function majReservation() {
    var reste = Math.max(0, echeance() - Date.now());
    var m = Math.floor(reste / 60000), s = Math.floor((reste % 60000) / 1000);
    var bande = racine && racine.querySelector('.earo-panier__reserve');
    if (bande) bande.innerHTML = 'Votre commande est réservée pendant <strong>' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s + '</strong> <span aria-hidden="true">⏰</span>';
  }
  function afficherErreur(message) {
    construire();
    var p = racine.querySelector('.earo-panier__erreur');
    p.textContent = message;
    p.hidden = false;
    clearTimeout(minuteurErreur);
    minuteurErreur = setTimeout(function () { p.hidden = true; }, 5000);
  }

  // ---------- Données ----------
  function chargerProduits() {
    var poignees = C.vision.concat(C.acou).filter(function (h, i, a) { return a.indexOf(h) === i && !produits[h]; });
    return Promise.all(poignees.map(function (h) {
      return json('/products/' + h + '.js').then(function (p) { produits[h] = p; }).catch(function () {});
    }));
  }
  // Icône du panier dans l'en-tête, redessinée par le thème (section cart-icon-bubble).
  var minuteurIcone = null;
  function majIcone() {
    clearTimeout(minuteurIcone);
    minuteurIcone = setTimeout(function () {
      var bulle = document.getElementById('cart-icon-bubble');
      if (!bulle) return;
      fetchOrigine('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d['cart-icon-bubble']) return;
          var section = new DOMParser().parseFromString(d['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (section) bulle.innerHTML = section.innerHTML;
        }).catch(function () {});
    }, 250);
  }
  function appliquer(c) {
    if (!estPanier(c)) return false;
    var avant = panier && panier.item_count;
    panier = c;
    rendre();
    if (avant !== c.item_count) majIcone();
    return true;
  }
  function rafraichir() {
    return json('/cart.js').then(appliquer).catch(function () {});
  }

  // ---------- Actions ----------
  function patienter(promesse) {
    occupe = true;
    corps.setAttribute('aria-busy', 'true');
    return promesse
      .then(function (d) { if (!appliquer(d)) return rafraichir(); })
      .catch(function (e) {
        afficherErreur(e && (e.statut === 422 || e.statut === 0) && e.message ? e.message : "Le panier n'a pas pu être mis à jour. Réessayez.");
        // Une requête abandonnée peut quand même aboutir chez Shopify : on relit le panier un peu plus tard.
        if (e && e.statut === 0) setTimeout(rafraichir, 5000);
        return rafraichir();
      })
      .then(function () { occupe = false; corps.removeAttribute('aria-busy'); });
  }
  function ligneParCle(cle) { return cle && panier ? panier.items.filter(function (x) { return x.key === cle; })[0] : null; }
  function changer(l, q) { return json('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: l.key, quantity: q }) }); }
  function clic(e) {
    var t = e.target.closest('[data-fermer], [data-commander], [data-qte], [data-cqte], [data-suppr], [data-ajouter]');
    if (!t) return;
    if (t.hasAttribute('data-fermer')) return fermer();
    if (t.hasAttribute('data-commander')) { t.setAttribute('aria-busy', 'true'); window.location.href = '/checkout'; return; }
    if (occupe || !panier) return;
    var cad = t.closest('[data-cadeau]');
    if (t.hasAttribute('data-cqte') && cad) return compterCadeau(cad, Number(t.getAttribute('data-cqte')));
    var ligne = t.closest('[data-cle]');
    var l = ligneParCle(ligne && ligne.getAttribute('data-cle'));
    if (t.hasAttribute('data-qte') && l) {
      var q = Math.max(0, l.quantity + Number(t.getAttribute('data-qte')));
      return q === 0 ? supprimer(l) : patienter(changer(l, q));
    }
    if (t.hasAttribute('data-suppr') && l) return supprimer(l);
    if (t.hasAttribute('data-ajouter')) {
      return patienter(json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(t.getAttribute('data-ajouter')), quantity: 1 }] }) }));
    }
  }
  // Compteur d'un cadeau : « + » ajoute une unité payante (ligne à part, jamais touchée par la gratuité Rapi) ;
  // « − » retire les unités payantes et s'arrête au nombre offert : Rapi remet de toute façon les cadeaux de l'offre
  // au chargement de la page (constaté le 16/10), retirer un cadeau ne tiendrait pas.
  function compterCadeau(cad, delta) {
    var g = ligneParCle(cad.getAttribute('data-cadeau'));
    var x = ligneParCle(cad.getAttribute('data-sup'));
    if (!g) return rafraichir();
    if (delta > 0) {
      if (x) return patienter(changer(x, x.quantity + 1));
      return patienter(json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: g.variant_id, quantity: 1, properties: { _earo_cadeau: cad.getAttribute('data-offre') } }] }) }));
    }
    if (x) return patienter(changer(x, x.quantity - 1));
  }
  function supprimer(l) {
    // Un article Rapi part avec ses cadeaux et les unités ajoutées à ces cadeaux.
    var maj = {}; maj[l.key] = 0;
    var o = offre(l);
    if (o && o.main) panier.items.forEach(function (g) {
      var og = offre(g);
      if ((og && og.gift && og.id === o.id) || (g.properties || {})._earo_cadeau === o.id) maj[g.key] = 0;
    });
    return patienter(json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: maj }) }));
  }

  var dernierFocus = null;
  function ouvrir() {
    construire();
    var dejaOuvert = racine.hasAttribute('data-ouvert');
    rendre();
    if (!dejaOuvert) {
      dernierFocus = document.activeElement;
      racine.setAttribute('data-ouvert', '');
      document.documentElement.classList.add('earo-panier-ouvert');
      setTimeout(function () { var b = racine.querySelector('.earo-panier__fermer'); if (b) b.focus({ preventScroll: true }); }, 50);
      clearInterval(minuteurReserve);
      minuteurReserve = setInterval(function () { if (panier && panier.item_count) majReservation(); }, 1000);
    }
    return Promise.all([chargerProduits(), rafraichir()]).then(rendre);
  }
  function fermer() {
    if (!racine) return;
    racine.removeAttribute('data-ouvert');
    document.documentElement.classList.remove('earo-panier-ouvert');
    clearInterval(minuteurReserve);
    if (dernierFocus && dernierFocus.focus) try { dernierFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  // ---------- Branchements ----------
  window.earoPanier = { ouvrir: ouvrir, fermer: fermer, rafraichir: rafraichir };
  // Rapi ouvre le panier par ces deux fonctions quand elles existent.
  window.upcartOpenCart = function () { ouvrir(); };
  window.upcartRefreshCart = function () { rafraichir(); };
  document.addEventListener('cart:refresh', function () { rafraichir(); });
  document.addEventListener('earo:panier-corrige', function () { rafraichir(); });

  // Modifications du panier faites ailleurs (Rapi, autres boutons, autres scripts) :
  // un ajout ouvre le panier, toute autre modification le remet à jour (évite des lignes périmées).
  var AJOUT = /\/cart\/add(\.js)?(\?|$)/;
  var MODIF = /\/cart\/(change|update|clear)(\.js)?(\?|$)/;
  var minuteurExterne = null;
  function modifExterne(ajout) {
    if (occupe) return;
    clearTimeout(minuteurExterne);
    minuteurExterne = setTimeout(function () { if (ajout) ouvrir(); else rafraichir(); }, ajout ? 400 : 300);
  }
  // Ajout fait par Rapi en coulisse (seulement ses cadeaux, ex. au chargement de la page) : on met à jour sans ouvrir.
  function cadeauxSeuls(init) {
    try {
      var d = init && typeof init.body === 'string' ? JSON.parse(init.body) : null;
      return !!(d && Array.isArray(d.items) && d.items.length && d.items.every(function (it) { return /"gift":true/.test((it.properties || {}).__rapi_offer || ''); }));
    } catch (e) { return false; }
  }
  var precedent = window.fetch;
  window.fetch = function (entree, init) {
    var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
    var p = precedent.apply(window, arguments);
    var ajout = AJOUT.test(url) && !cadeauxSeuls(init);
    if (AJOUT.test(url) || MODIF.test(url)) p.then(function (r) { if (r && r.ok) modifExterne(ajout); }).catch(function () {});
    return p;
  };
  var ouvrirXhr = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    var u = String(url), ajout = AJOUT.test(u);
    if (ajout || MODIF.test(u)) this.addEventListener('load', function () { if (this.status < 400) modifExterne(ajout); });
    return ouvrirXhr.apply(this, arguments);
  };

  // Icône et liens du panier : ouvrir le tiroir au lieu de la page /cart.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"], a[href$="/cart"], #cart-icon-bubble');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    ouvrir();
  }, true);

  function demarrer() {
    construire();
    if (panier) rendre();
    rafraichir();
    if ('requestIdleCallback' in window) requestIdleCallback(function () { chargerProduits(); }); else setTimeout(chargerProduits, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
